import React, { ChangeEvent, useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import styles from './About.module.css';
import { ValueCallback } from 'types/callbacks';

// TODO(arthur): Fix these material UI styling issues.
export const CustomSwitch = withStyles(() => ({
  root: {
    width: 48,
    height: 24,
    padding: 0,
    display: 'flex',
  },
  switchBase: {
    padding: 0,
    '&$checked': {
      transform: 'translateX(24px)',
      color: 'white',
      '& + $track': {
        opacity: 1,
        backgroundColor: '#57A5E0',
      },
    },
  },
  thumb: {
    width: 20,
    height: 20,
    marginTop: 2,
    marginLeft: 2,
    boxShadow: 'none',
  },
  track: {
    borderRadius: 24 / 2,
    opacity: 1,
    backgroundColor: '#0b0b0b',
  },
  checked: {},
}))(Switch);

type Props = {
  label?: string;
  initialValue?: boolean;
  onChange?: ValueCallback<boolean>;
};

const RiveSwitch = ({ label, initialValue = false, onChange }: Props) => {
  const [isChecked, setChecked] = useState<boolean>(initialValue);

  useEffect(() => setChecked(initialValue), [initialValue]);

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    setChecked(event.target.checked);
    onChange && onChange(event.target.checked);
  }

  return (
    <div className={styles.SwitchContainer}>
      <h3>{label}</h3>
      <CustomSwitch
        className={styles.Switch}
        checked={isChecked}
        onChange={handleChange}
        name="checked"
      />
    </div>
  );
};

export default RiveSwitch;
